import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { login, changePassword, getLoggedUser } from 'Api/Login';
import { getToken } from '../Utils/Token';

export const fetchUser = createAsyncThunk('loggedUser/fetchUser', async params => {
  const response = await login(params.payrollNum, params.password);
  if (response.error) {
    params.catchError(response.errorMessage);
    return response;
  }
  if (!response.User_login.status) {
    params.catchError('Account deactivated');
    return response;
  }
  params.clearError();
  return response.User_login;
});

export const fetchLoggedUser = createAsyncThunk('loggedUser/fetchLoggedUser', async () => {
  if (!getToken()) {
    return { error: true };
  }
  const response = await getLoggedUser();

  // El wrapper devuelve { error, errorCode, errorMessage } cuando el backend
  // reporta UNAUTHORIZED/USER_NOT_FOUND/FORBIDDEN; en ese caso ya no existe
  // `User_logged` en el payload.
  if (response?.error) {
    return { error: true };
  }

  return response.User_logged;
});

export const setFirstPassword = createAsyncThunk('loggedUser/setFirstPassword', async state => {
  const response = await changePassword(state.old, state.new);

  if (response.error) {
    state.catchError(response.errorMessage);
  }

  state.clearErrors();
  return response.User_changePassword;
});

export const loggedUserSlice = createSlice({
  name: 'loggedUser',
  initialState: {
    loggedUser: null,
    isUserLogged: null,
  },
  reducers: {
    clear: state => {
      state = {
        loggedUser: {},
        isUserLogged: false,
      };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(fetchUser.pending, state => {
        state.isUserLogged = false;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        if (action.payload.error) {
          state.loggedUser = {};
          state.isUserLogged = false;
          return;
        }
        state.loggedUser = { ...action.payload };

        if (action.payload?.token) {
          state.isUserLogged = true;
        } else {
          state.isUserLogged = false;
        }
      })
      .addCase(setFirstPassword.pending, state => {
        state.loggedUser = {
          ...state.loggedUser,
          isFirstTime: false,
        };
      })
      .addCase(setFirstPassword.fulfilled, (state, action) => {
        if (action.payload.error || action.payload.transactionStaus === false) {
          state.loggedUser = {};
          state.isUserLogged = false;
          return;
        }

        state.loggedUser = { ...state.loggedUser, ...action.payload };
      })
      .addCase(fetchLoggedUser.pending, state => {
        state.loading = true;
      })
      .addCase(fetchLoggedUser.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.error) {
          state.loggedUser = {};
          state.isUserLogged = false;
          return;
        }
        state.loggedUser = { ...action.payload };
        state.isUserLogged = true;
      });
  },
});

export const userSelector = state => (state.loggedUser.loggedUser ? state.loggedUser.loggedUser : {});

export const isUserLoggedSelector = state => state.loggedUser.isUserLogged;

export const isFirstLogin = state => state.loggedUser.loggedUser?.isFirstTime;

export default loggedUserSlice.reducer;
